import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getAllActiveItemCategory,
    GetFactoryItemsByFactoryIDItemCategory,
    GetTotalFactoryItemStatusReport
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetTotalFactoryItemStatusReport(operationEntityID, collectionPointID, itemCategoryID, factoryItemID, toDate, fromDate, statusID ) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: parseInt(collectionPointID),
        itemCategoryID: parseInt(itemCategoryID),
        factoryItemID: parseInt(factoryItemID) ,
        toDate: toDate,
        fromDate: fromDate,
        statusID: parseInt(statusID)
        
    }
        console.log(newModel)

    const response = await CommonPost('/api/FactoryItemStatusReport/GetTotalFactoryItemStatusReport', null, newModel);
    return response.data;
}
async function getAllActiveItemCategory() {

    const response = await CommonGet('/api/FactoryItemCategory/GetAllActiveItemCategory', null);
    let factoryArray = []

    for (let item of Object.entries(response.data)) {

        factoryArray[item[1]["itemCategoryID"]] = item[1]["categoryName"]
    }
    return factoryArray;

}
async function GetFactoryItemsByFactoryIDItemCategory(itemCategoryID,operationEntityID) {

    const response = await CommonGet('/api/FactoryItem/GetFactoryItemsByFactoryIDCollectionCategory', 'operationEntityID=' + operationEntityID + '&itemCategoryID=' + itemCategoryID );
    let factoryArray = []

    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["itemCategoryID"] === parseInt(itemCategoryID)){
        factoryArray[item[1]["factoryItemID"]] = item[1]["factoryItemName"]
    }
}
    console.log(factoryArray)
    console.log(response.data)
    return factoryArray;
}